/**
 *
 * 注册所有组件
 */

import LmHeader from "@/components/LmHeader.vue";
import LmFooter from "@/components/LmFooter.vue";
import LmImg from "@/components/lm-img/index.vue";
class ComponentConfig {
    static createComponent(vue:any) {
        vue.component("lm-header", LmHeader);
        vue.component("lm-footer", LmFooter);
        vue.component("lm-img", LmImg);
    }
}
export default ComponentConfig;
